import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  HostBinding,
  Input,
} from '@angular/core';
import { AlertLevel } from './alert.interface';
import { AlertFooterDirective, AlertIconDirective } from './alert-sections';
import { AlertIconComponent } from './alert-icon.component';

@Component({
    selector: 'lui-alert',
    template: `<div class="alert-container">
    <div class="alert-Icon" *ngIf="icon">
      <ng-content select="[luiAlertIcon]"></ng-content>
    </div>
    <div class="alert-Icon" *ngIf="iconComponent">
      <ng-content select="lui-alert-icon"></ng-content>
    </div>
    <div class="alert-content">
      <ng-content></ng-content>
    </div>
    <div class="alert-footer-content" *ngIf="footer">
      <ng-content select="[luiAlertFooter]"></ng-content>
    </div>
  </div> `,
    styleUrls: ['./alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AlertComponent {
  @Input() level: AlertLevel = 'info';

  @HostBinding('class.lui-alert-info') get infoLevelCass() {
    return this.level === 'info';
  }
  @HostBinding('class.lui-alert-elevated') get elevatedLevelCass() {
    return this.level === 'elevated';
  }
  @HostBinding('class.lui-alert-success') get successLevelCass() {
    return this.level === 'success';
  }
  @HostBinding('class.lui-alert-danger') get dangerLevelCass() {
    return this.level === 'danger';
  }
  @HostBinding('class.lui-alert-info-solid') get infoSolidLevelCass() {
    return this.level === 'info-solid';
  }
  @HostBinding('class.lui-alert-elevated-solid') get elevatedSolidLevelCass() {
    return this.level === 'elevated-solid';
  }
  @HostBinding('class.lui-alert-success-solid') get successSolidLevelCass() {
    return this.level === 'success-solid';
  }
  @HostBinding('class.lui-alert-danger-solid') get dangerSolidLevelCass() {
    return this.level === 'danger-solid';
  }

  @ContentChild(AlertIconDirective) icon!: AlertIconDirective;
  @ContentChild(AlertIconComponent) iconComponent!: AlertIconComponent;
  @ContentChild(AlertFooterDirective) footer!: AlertFooterDirective;
}
